import Cookies from 'js-cookie';

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

async function request(path: string, method: HttpMethod, body?: any, csrfToken?: string) {
  const headers: Record<string, string> = { 'Accept': 'application/json' };
  let payload: BodyInit | undefined;
  if (body && !(body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
    payload = JSON.stringify(body);
  } else if (body instanceof FormData) {
    payload = body;
  }
  if (csrfToken) headers['X-CSRF-Token'] = csrfToken;

  const res = await fetch(path, {
    method,
    headers,
    body: payload,
    credentials: 'include'
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || res.statusText);
  }
  const contentType = res.headers.get('content-type') || '';
  if (contentType.includes('application/json')) return res.json();
  return res.text();
}

export const api = {
  get: (path: string) => request(path, 'GET'),
  post: (path: string, body: any, csrfToken?: string) => request(path, 'POST', body, csrfToken),
  put: (path: string, body: any, csrfToken?: string) => request(path, 'PUT', body, csrfToken),
  del: (path: string, body?: any, csrfToken?: string) => request(path, 'DELETE', body, csrfToken),
  upload: (path: string, form: FormData, csrfToken?: string) => request(path, 'POST', form, csrfToken)
};

export function getCsrfToken() {
  return Cookies.get('csrf_token');
}


